var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"c-points",class:`c-points--${_vm.type}`,on:{"click":_vm.handleClick}},[_vm._v(" "+_vm._s(Math.max(_vm.points, 0))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }